import React from 'react';
import PropTypes from 'prop-types';
import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';

import { placeholder43Url, prepareImgixParams } from '../../services/APIClient';

const BrandPhotoCard = ({
  ableToEdit,
  photo,
  onImageClick,
  brandSlug,
}) => (
  <div className="column column-block">
    <div className="card responsive-image">
      <div
        className="img-standard image-overlay-info"
        style={{
          backgroundImage: `url(${placeholder43Url})`,
          cursor: 'zoom-in',
        }}
        onClick={() => onImageClick(photo.mediaItemAttributionId)}
        role="button"
        tabIndex={0}
      >
        <div
          className="p-a img-standard lazyload"
          data-bg={photo.url ? prepareImgixParams(photo.url, { w: 320, h: 240, auto: 'format,compress' }) : placeholder43Url}
          style={{ top: 0 }}
        />
        <div className="overlay" />
        <div className="info p-0">
          <div className="row align-middle collapse" style={{ height: '100%' }}>
            <div className="column">
              {ableToEdit && (
              <div className="control top p-s flex-container align-center-middle" style={{ height: '100%' }}>
                <a
                  className="button tiny br-max black-button black-button-transparent pt-xs pb-xs pl-base pr-base"
                  href={`/brands/${brandSlug}/photos/edit/${photo.mediaItemAttributionId}/`}
                  target="_blank"
                  rel="noreferrer"
                  onClick={e => e.stopPropagation()}
                  role="button"
                  tabIndex={0}
                >
                  <span>Edit</span>
                </a>
              </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

BrandPhotoCard.propTypes = {
  ableToEdit: PropTypes.bool,
  brandSlug: PropTypes.string.isRequired,
  photo: PropTypes.shape({
    globalId: PropTypes.string,
    mediaId: PropTypes.string,
    url: PropTypes.string,
    mediaItemAttributionId: PropTypes.string,
  }),
  onImageClick: PropTypes.func,
};

BrandPhotoCard.defaultProps = {
  ableToEdit: false,
  photo: {
    globalId: '',
    mediaId: '',
    url: '',
    mediaItemAttributionId: '',
  },
  onImageClick: () => {},
};

export default BrandPhotoCard;
